<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>新增留存 (日留存率=  第N天活跃用户数 / 第1天注册用户数 ×100%)
          </span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="平台" prop="platForm">
            <el-select v-model="queryParams.platForm" style="width: 130px" placeholder="请选择">
              <el-option
                v-for="item in platForm"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="国家" prop="countryArr">
            <el-select v-model="queryParams.countryArr" style="width: 300px;" multiple filterable placeholder="请选择">
              <el-option
                v-for="item in country"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="isOptionDisabled(item.value)"
                @change="handleSelectChange"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="登录方式" prop="adChannel">
            <el-select v-model="queryParams.adChannel" filterable placeholder="请选择">
              <el-option
                v-for="item in adChannel"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button v-permisaction="['config:userRemain:export']" :loading="loading" icon="el-icon-download" size="mini" @click="exportData(3)">导出</el-button>
          </el-form-item>
        </el-form>
        <div ref="chartContainer" style="width: 100%; height: 400px;" />

      </el-card>

      <el-card>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
            width="100px"
          />
          <el-table-column
            prop="regCount"
            label="新增用户"
          />
          <el-table-column
            prop="remain.1"
            label="次日"
            :formatter="numFormatter"
          />
          <el-table-column
            prop="remain.2"
            label="3日"
            :formatter="numFormatter"
          />
          <el-table-column
            prop="remain.3"
            label="4日"
            :formatter="numFormatter"
          />
          <el-table-column
            prop="remain.4"
            label="5日"
            :formatter="numFormatter"
          />
          <el-table-column
            prop="remain.5"
            label="6日"
            :formatter="numFormatter"
          />
          <el-table-column
            prop="remain.6"
            label="7日"
            :formatter="numFormatter"
          />
          <el-table-column
            prop="remain.14"
            label="15日"
            :formatter="numFormatter"
          />
          <el-table-column
            prop="remain.29"
            label="30日"
            :formatter="numFormatter"
          />
        </el-table>
      </el-card>

      <el-card>
        <div slot="header" class="clearfix">
          <span>DAU/MAU</span>
        </div>
        <DauMau />
      </el-card>

      <el-card>
        <LoginRemain />
      </el-card>

      <el-card>
        <PayRemain />
      </el-card>

      <el-card>
        <PayLoginRemain />
      </el-card>

    </template>

  </BasicLayout>
</template>

<script>
import { exportStatData, getUserRemain } from '@/api/statistics/user_remain'
import LoginRemain from '@/components/userRemain/LoginRemain.vue'
import PayRemain from '@/components/Index/PayRemain.vue'
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'
import PayLoginRemain from '@/components/Index/PayLoginRemain.vue'
import DauMau from '@/views/config/user-remain/components/dau_mau.vue'

export default {
  name: 'UserRemain',
  components: {
    PayLoginRemain,
    LoginRemain,
    PayRemain,
    DauMau
  },
  data() {
    return {
      country: [],
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        countryArr: [],
        platForm: '',
        adChannel: '',
        type: 3
      },
      platForm: [{ label: '全部', value: '' }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }, { label: 'TG', value: 3 }],
      adChannel: [{ label: '全部', value: '' }, { label: '游客', value: 'GUEST' }, { label: 'FACEBOOK', value: 'FACEBOOK' }, { label: '苹果', value: 'APPLE' }, { label: '谷歌', value: 'GOOGLE' }],
      loading: false,
      options: [],
      tableData: [],
      tableData2: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  created() {
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.loading = true
      this.getTables()
    },
    getTables() {
      getUserRemain(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.r
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          const country = res.data.country
          const remain = res.data.r
          const loginData = res.data.rl
          this.country = [{ value: '', label: '全部' }]
          for (const i in country) {
            this.country.push({ value: i, label: country[i] })
          }

          for (const i in remain) {
            const r = remain[i]
            for (const k in loginData) {
              const login = loginData[k]
              if (login.Date === r.date && r.regCount > 0) {
                let rate = (parseFloat((login.LogCount / r.regCount)) * 100).toFixed(2)
                if (rate > 100) {
                  rate = 100
                }
                remain[i].remain[login.DiffDay] = rate
              }
            }
          }
          const day1 = []
          const day3 = []
          const day4 = []
          const day5 = []
          const day6 = []
          const day7 = []
          const day15 = []
          const day30 = []
          this.date = []
          remain.forEach((item) => {
            this.date.push(dateStrTodate(item.date))
            for (const i in item.remain) {
              const val = item.remain[i]
              console.log(typeof i)
              switch (i) {
                case '1':
                  day1.push(val)
                  break
                case '2':
                  day3.push(val)
                  break
                case '3':
                  day4.push(val)
                  break
                case '4':
                  day5.push(val)
                  break
                case '5':
                  day6.push(val)
                  break
                case '6':
                  day7.push(val)
                  break
                case '14':
                  day15.push(val)
                  break
                case '29':
                  day30.push(val)
                  break
              }
            }
          })

          this.option.xAxis.data = this.date
          this.option.series[0].data = day1
          this.option.series[1].data = day3
          this.option.series[2].data = day4
          this.option.series[3].data = day5
          this.option.series[4].data = day6
          this.option.series[5].data = day7
          this.option.series[6].data = day15
          this.option.series[7].data = day30
          this.chart.setOption(this.option)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '新增留存'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['次日', '3日', '4日', '5日', '6日', '7日', '15日', '30日'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '次日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '3日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '4日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '5日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '6日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '7日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '15日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '30日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    exportData(typ) {
      this.loading = true
      exportStatData(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    isOptionDisabled(value) {
      if (value === 'all') {
        return this.queryParams.countryArr.length > 0 && !this.queryParams.countryArr.includes('')
      } else {
        return this.queryParams.countryArr.includes('')
      }
    },
    handleSelectChange(val) {
      if (val.includes('')) {
        this.queryParams.countryArr = ['']
      } else if (val.length > 1 && val.indexOf('') !== -1) {
        this.queryParams.countryArr = ['']
      }
    }
  }
}
</script>

<style scoped>
</style>
